import type { GetPolicyResponse } from "@/openapi/generated";
import { waiverAnchorId } from "../../components/TermsTableOfContents";

export interface TermsMemberNavItem {
  key: string;
  anchorId: string;
  label: string;
  isPending: boolean;
}

export function buildTermsMemberNavItems(
  waivers: GetPolicyResponse[],
): TermsMemberNavItem[] {
  return waivers.map((waiver) => {
    const isPending = waiver.acceptedAt == null;

    return {
      key: String(waiver.policyId),
      anchorId: waiverAnchorId(waiver.policyId),
      label: waiver.name?.trim() || "Waiver",
      isPending,
    };
  });
}

export function formatTermsMemberNavLabel(item: TermsMemberNavItem): string {
  if (item.isPending) {
    return `${item.label} (Pending)`;
  }

  return item.label;
}

/** Mobile chip labels - pending state shown via visual indicator instead. */
export function formatTermsMemberNavMobileLabel(item: TermsMemberNavItem): string {
  return item.label;
}

export function getTermsMemberNavDescription(
  items: TermsMemberNavItem[],
  activeKey: string,
): string {
  const activeItem = items.find((item) => item.key === activeKey);

  if (!activeItem) {
    return "Jump to a waiver on this page.";
  }

  return activeItem.isPending
    ? "Review the waiver text and sign when you are ready."
    : "View your signed waiver and acceptance details.";
}

export { scrollToTermsWaiver } from "../../components/TermsTableOfContents";
